export const TOKEN_KEY = "NMCTOKEN2019@123";
export const SUCURSAL='SUCURSAL'
export const USER_KEY = "NMCUSER2019@123";
export const isAuthenticated = () => localStorage.getItem(USER_KEY) !== null;
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const defaultPassword='sge2019'

export const login = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};
export const getUserDetails = () =>localStorage.getItem(USER_KEY);
export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(SUCURSAL);
  localStorage.removeItem('STUDENT_FILTER_YEAR');
  localStorage.removeItem('STUDENT_RENEW_FILTER_YEAR');
  localStorage.removeItem('PAYMENT_FILTER_YEAR');
  localStorage.removeItem('LAST_STUDENT');
  localStorage.removeItem('student_data');
};

// Ported from sge_infantil_web/src/utils/auth.js
export const getUserInfo = () => {
  const user = localStorage.getItem(USER_KEY);
  return user ? JSON.parse(user) : null;
};

export const getSucursalInfo = () => {
  const sucursal = localStorage.getItem(SUCURSAL);
  return sucursal ? JSON.parse(sucursal) : null;
};

// The one sucursal allowed to hold more than one active registration per
// student per year (e.g. a student enrolled in two different courses at
// once) — every other sucursal enforces a single registration per
// student+year. Hardcoded ID matches GLOBAL_ACADEMY_SUCURSAL_ID in
// sge_infantil_core's utils/constants.js, where the backend applies the
// same special-casing for enrolment/payment behaviour.
export const GLOBAL_ACADEMY_SUCURSAL_ID = "d1f550c0-5356-4d8e-b47b-b770fb91d414";
export const isGlobalAcademy = (sucursal) => (sucursal || getSucursalInfo())?.id === GLOBAL_ACADEMY_SUCURSAL_ID;

// Whether this sucursal offers a "horário especial" (extended schedule) with
// its own monthly fee on top of the course's standard fee — data-driven via
// the sucursal's own useSpecialHourAmount flag (sge_infantil_core's
// SUCURSAL_TABLE), not a hardcoded list of sucursal IDs/names, so any
// sucursal can opt in just by having the flag set to 1.
export const hasSpecialHourSchedule = (sucursal) => {
  const flag = (sucursal || getSucursalInfo())?.useSpecialHourAmount;
  // eslint-disable-next-line eqeqeq
  return flag == 1;
};

// Whether this sucursal follows the Cambridge Assessment International
// Education boletim model (3 weighted categories + Behaviour, grades in %,
// A*-U letters) instead of the national model (0-20, free evaluations) —
// data-driven via the sucursal's own isCambridge flag (sge_infantil_core's
// SUCURSAL_TABLE, updated through the same PUT /api/sucursal/:id used by
// pautaVisivelWhatsapp etc. — see services/config.js).
export const isCambridgeSucursal = (sucursal) => {
  const flag = (sucursal || getSucursalInfo())?.isCambridge;
  // eslint-disable-next-line eqeqeq
  return flag == 1;
};

// Legacy profile codes (see sge_infantil_core's authorityMap in routes/user.js
// and LEGACY_PROFILE_DESCRIPTIONS in scripts/seed-legacy-profiles-and-migrate-users.js):
// '002' = Admin, '003' = Professor(a), '004' = Director(a) / Director Pedagógico, '005' = Super Admin.
export const isProfessor = () => getUserInfo()?.profile?.code === "003";
export const isDirectorPedagogico = () => getUserInfo()?.profile?.code === "004";

// Admin (002), Director Pedagógico (004) e Super Admin (005) podem editar as
// notas de uma pauta independentemente do estado em que ela esteja (DRAFT,
// FINALIZED, PUBLISHED ou CHANGE) — os restantes perfis só editam em DRAFT.
export const canEditGradebookAnyStatus = () => ["002", "004", "005"].includes(getUserInfo()?.profile?.code);

// Super Admin (005), Admin (002), Director(a) (004) e Gestor Administrativo (011) are
// the only profiles allowed to manage a "Taxa e Emolumento" charge once it's been
// applied to a student: permanently removing it (ListaTaxasLayer's config-entry delete,
// and a student's unpaid/partial tax charge on ListaPropinasLayer's "Taxas" section),
// or anulling (reverting to unpaid) one already marked paid/partial on that same
// section. Mirrors sge_infantil_web's ListaPropinasLayer.REMOVE_PROPINA_PROFILE_CODES
// gate for the equivalent propina actions. Both operations hit sge_infantil_core's
// routes/emoluments.js (DELETE /payments/:registrationId/:taxId and
// PUT /payments/anull/:registrationId/:taxId, plus DELETE /:id for the config entry).
export const canRemoveTaxEmolument = () => ["002", "004", "005", "011"].includes(getUserInfo()?.profile?.code);

// Fail-closed: a user whose profile has no valid `permissions` array (legacy
// Profile rows never migrated by sge_infantil_core's
// scripts/seed-legacy-profiles-and-migrate-users.js — confirmed still ~34%
// of GLOBAL_PROFILES as of 2026-08-27) sees NOTHING instead of everything.
// This used to be fail-open on purpose (so rolling out the permissions
// system never locked anyone out), but that meant every unmigrated profile
// had full access to every screen, old and new, forever — the opposite of
// what "only these roles should see X" (e.g. Auditoria) can mean if it's not
// enforced here too. '*' is the explicit wildcard used by Admin/Super Admin
// profiles (and any other profile a human deliberately grants full access).
export const hasPermission = (permissionCode) => {
  const user = getUserInfo();
  const permissions = user?.permissions;
  if (!Array.isArray(permissions)) return false;
  if (permissions.includes('*')) return true;
  return permissions.includes(permissionCode);
};
